import React, { useEffect, useCallback } from 'react'
import { TextBoxComponent } from '@syncfusion/ej2-react-inputs'
import { useEventHandler, useInstData } from 'tyan/public/hooks'
import IconButton from '../IconButton'

const TextArea = props => {
	const {
		commonProps, commonProps: { enabled },
		compProps: { noLocale, clearable, name = 'input', buttons = [], tooltip, maxRows, autoSize, resizable, maxLength, richtext, fontSize, monospace },
		onChange, value, focusStamp, richeditable,
		onWordEdit, onShowRTEDialog,
		_validStamp
	} = props

	const { me, setState, me: { state: { edited } } } = useInstData(props)

	const handleChange = useEventHandler(e => {
		onChange(e.value)
		!me.state.edited && setState({ edited: true })
	})

	// autoSize && (maxRows = 1)

	useEffect(() => {
		me.textArea && me.textArea.addAttributes({
			rows: maxRows,
			maxlength: maxLength
		})
	}, [maxRows, maxLength])

	const handleButtonFocus = useCallback(() => {
		me.textArea.focusIn();
	}, [])

	const handleShowWordEditor = () => onWordEdit && onWordEdit()
	const handleShowRichtextEditor = () => onShowRTEDialog && onShowRTEDialog()

	const handleKeyDown = useEventHandler(event => {
		if (event.keyCode !== 13 || event.altKey || !event.ctrlKey) return

		event.preventDefault()

		if (event.repeat) return

		event.shiftKey ? handleShowWordEditor() : richeditable && handleShowRichtextEditor()
	})

	useEffect(() => {
		if (richtext && me.textArea) {
			enabled && me.textArea.respectiveElement.addEventListener('keydown', handleKeyDown)
			return () => me.textArea.respectiveElement.removeEventListener('keydown', handleKeyDown)
		}
	}, [richtext, enabled])

	useEffect(() => {
		focusStamp && focusStamp != me.focusStamp && (me.focusStamp = focusStamp, me.textArea.focusIn())
	}, [focusStamp])

	const buttonCommonProps = { noLocale: true, disabled: !enabled }
	const allButtons = (richtext
		? (richeditable
			? [{ icon: 'edit', text: `${Tyan.t('编辑')}(Ctrl + Enter)`, ...buttonCommonProps, handler: handleShowRichtextEditor }]
			: []
		).concat([
			{ icon: 'file-word-o', text: `${Tyan.t('打开Word编辑器')}(Ctrl + Shift + Enter)`, ...buttonCommonProps, handler: handleShowWordEditor },
		])
		: [])
		.concat(buttons)

	const cssClass = !value && (edited || _validStamp) ? 't-input-group e-error' : 't-input-group'
	return <div className='t-multiline-wrapper'
		style={{ fontSize }}>{/* <div className={groupClass} style={{ width: '100%', flex: '1 1 0%', fontSize }}> */}
		<TextBoxComponent ref={ref => ref && (/* window.textArea =  */me.textArea = ref)}
			{...commonProps} {...(monospace ? { cssClass: 't-monospace' } : {})}
			{...{
				autocomplete: false, multiline: true,
				showClearButton: clearable,
				value, input: handleChange,
				cssClass
				// htmlAttributes: { style: `font-size:${fontSize};` }
			}}
		/>
		<div className='t-multiline-buttons-wrapper'>
			{allButtons.map((button, index) => <IconButton key={index} {...{ button, value, onFocus: handleButtonFocus }} />)}
		</div>
	</div >
}


export default TextArea